export default __webpack_public_path__ + "static/media/desktop.b56f6309.png";